import { useRootPlacesQuery } from '~/libs/gql/queries/root_places/rootPlacesQuery.generated';

export const useRootPlacesData = () => {
  const query = useRootPlacesQuery({
    variables: {
      isFeatured: true,
    },
  });
  return query;
};
